import {JSX, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {usePreferredLocale} from "../../api/settings/settingsQueries";

type LocaleInitializerProps = {
    children: JSX.Element;
};

const LocaleInitializer = ({children}: LocaleInitializerProps) => {
    const {i18n} = useTranslation();
    const preferredLocaleQuery = usePreferredLocale();

    useEffect(() => {
        const preferredLocale = preferredLocaleQuery.data?.preferredLocale;
        if (!preferredLocale) {
            return;
        }
        if (preferredLocale !== i18n.language) {
            void i18n.changeLanguage(preferredLocale);
        }
    }, [preferredLocaleQuery.data?.preferredLocale, i18n]);

    return children;
};

export default LocaleInitializer;
